import styled from 'styled-components';
import { background, text } from '@carvana/helios-styles';
import { body, heading } from '@carvana/helios-typography';
import { breakpoint } from '@carvana/helios-layout';

const Background = styled.div`
  background-color: ${background.weak};
  display: flex;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
`;

const Container = styled.div`
  padding: 64px 24px;
  max-width: 559px;
  width: 100%;
  box-sizing: border-box;

  ${breakpoint.sm`
    padding: 80px 32px;
    max-width: 959px;
  `}

  ${breakpoint.md`
    max-width: 959px;
    padding: 80px 0px;
  `};

  ${breakpoint.lg`
    max-width: 1272px;
    padding: 80px 0px;
  `};
`;

const CarouselHeader = styled.div`
  ${breakpoint.md`
    margin-right: -75px;
  `}
`;

const ReviewContainer = styled.div`
  width: 300px;

  ${breakpoint.md`
    width: 408px;
  `}
`;

const Title = styled.h2`
  ${heading['2Xl']};
  color: ${text.strong};
  margin-bottom: 40px;

  ${breakpoint.md`
    ${heading['3Xl']};
  `}

  &.capitalize {
    text-transform: capitalize;
  }
`;

const Info = styled.p`
  color: ${text.strong};
  ${body.md};
  font-weight: 500;

  ${breakpoint.sm`
    max-width: 522px;
  `}

  ${breakpoint.md`
    min-width: 650px;
    max-width: 744px;
  `}
`;

const Link = styled.a`
  color: ${text.primary};
  display: inline;
  text-decoration: underline;
  margin-left: 5px;
`;

const StarContainer = styled.div`
  margin-bottom: 8px;
`;

const TotalRating = styled.h2`
  ${heading['3Xl']};
  color: ${text.strong};
  margin-bottom: 4px;
`;

export {
  Background,
  Container,
  CarouselHeader,
  Info,
  ReviewContainer,
  Title,
  Link,
  StarContainer,
  TotalRating
};
